import { gql } from "@apollo/client"

const TOUCHPOINT_JOB_STEP_FIELDS = gql`
  fragment TouchpointJobStepFields on TouchpointJobStep {
    id
    step
    number
    section
    name
    responseType
    responseMandatory
    responseNfcId
    description
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    notes {
      ...JobStepNotesFields
    }
    allowedTouchpoints {
      id
      nfcId
    }
    repeatable
  }
`

export { TOUCHPOINT_JOB_STEP_FIELDS }
